import { boot } from 'quasar/wrappers';
import axios from 'axios';
import { encrypt, makeSecureToken } from 'src/model/encrypt';
import secretService from 'src/services/secret.service';
import { accessInfo } from 'src/model/access';

const md5 = require('js-md5');

/* eslint-disable */
export const LMS = process.env.LMS;
export const API_HOST = process.env.API_HOST;
export const STREAMING_URL = process.env.STREAMING_URL;
export const WEBINARS_API = process.env.WEBINARS_API;
export const CHAT_MODE = process.env.CHAT_MODE;
export const LMS_CHAT_URL = process.env.LMS_CHAT_URL;
export const LMS_CHAT_CLIENTS_URL = process.env.LMS_CHAT_CLIENTS_URL;
export const TG_BOT_NAME = process.env.TG_BOT_NAME;
export const IS_INTERNAL_AUTH = process.env.IS_INTERNAL_AUTH;
export const LMS_TITLE = process.env.LMS_TITLE;
export const LMS_DESCRIPTION = process.env.LMS_DESCRIPTION;
export const LMS_IMAGE = process.env.LMS_IMAGE;
export const SECURE_SECRET = process.env.SECURE_SECRET;
export const COMPILER_API = process.env.COMPILER_API;
export const PDF_GENERATOR_API = process.env.PDF_GENERATOR_API;
export const USE_SSO = process.env.USE_SSO;
export const SSO_CLIENT_ID = process.env.SSO_CLIENT_ID;
export const SSO_REDIRECT_URI = process.env.SSO_REDIRECT_URI;
export const USE_PARTNER = process.env.USE_PARTNER;
export const MERCHANT_LOGIN = process.env.MERCHANT_LOGIN;
export const MERCHANT_PASSWORD = process.env.MERCHANT_PASSWORD;
export const HIDDEN_COLUMNS = process.env.HIDDEN_COLUMNS;
/* eslint-enable */

const tgBotToken = process.env.BOT_TOKEN;

const isDebug = false;

// В режиме отладки работаем только с тестовыми данными
const workUrl = `${API_HOST}/api`;

const botWorkUrl = `${API_HOST}/api`;
const botDebugUrl = `${API_HOST}/api_debug`;

// при публикации на сервер вот это!
const workUrlProd = '/api';

const sha256 = require('js-sha256');

const apiBot = axios.create({ baseURL: isDebug ? botDebugUrl : botWorkUrl });
apiBot.botToken = tgBotToken;
apiBot.apiDir = isDebug ? 'api_debug' : 'api';

const api = axios.create({ baseURL: process.env.DEV ? workUrl : workUrlProd });
api.botToken = tgBotToken;
api.botUrl = isDebug ? botDebugUrl : botWorkUrl;

export default boot(({ app }) => {
    app.config.globalProperties.$axios = axios;
    app.config.globalProperties.$api = api;
    // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
    //       so you can easily perform requests against your app's API
});

export { api };
export { apiBot };

export function login (username, password, operatorKey = '') {
    const data = new FormData();
    data.append('email', username);
    data.append('password', password);
    if (operatorKey) {
        data.append('operatorKey', operatorKey);
    }
    return api.post('/auth.php', data);
}

export function query (sql) {
    const data = new FormData();
    data.append('query', sql);
    return api.post('query.php', data);
}

export async function queryRowCount (sql) {
    const k = sessionStorage.getItem('k1');
    if (!k) {
        await secretService.getKey();
    }
    // console.trace(sql);
    const data = new FormData();
    data.append('query', encrypt(sql));
    const stoken = makeSecureToken(sql);
    data.append('stoken', stoken);

    if (accessInfo) {
        const { operatorId } = accessInfo;
        if (operatorId) {
            const token = md5(operatorId);
            data.append('token', token);
        }
    }

    return apiBot.post('queryRowCount.php', data);
}

export async function queryBot (sql) {
    const k = sessionStorage.getItem('k1');
    if (!k) {
        await secretService.getKey();
    }
    // console.trace(sql);
    const data = new FormData();
    data.append('query', encrypt(sql));
    const stoken = makeSecureToken(sql);
    data.append('stoken', stoken);

    if (accessInfo) {
        const { operatorId } = accessInfo;
        if (operatorId) {
            const token = md5(operatorId);
            data.append('token', token);
        }
    }

    return apiBot.post('query.php', data);
}

export async function queryOne (sql) {
    const k = sessionStorage.getItem('k1');
    if (!k) {
        await apiBot.get('hello2.php').then((response) => {
            let { data } = response;
            data = data.slice(0, -10);
            data = data.substring(12);
            data = JSON.parse(atob(data));
            sessionStorage.setItem('k1', data.kmsJs93d);
            sessionStorage.setItem('v2', data.nnzbxvVd3h);
        });
    }

    const data = new FormData();
    data.append('query', encrypt(sql));
    const stoken = makeSecureToken(sql);
    data.append('stoken', stoken);
    const response = await apiBot.post('query.php', data);
    return response.data[0];
}

export async function queryMany (sql) {
    const k = sessionStorage.getItem('k1');
    if (!k) {
        await apiBot.get('hello2.php').then((response) => {
            let { data } = response;
            data = data.slice(0, -10);
            data = data.substring(12);
            data = JSON.parse(atob(data));
            sessionStorage.setItem('k1', data.kmsJs93d);
            sessionStorage.setItem('v2', data.nnzbxvVd3h);
        });
    }

    const data = new FormData();
    data.append('query', encrypt(sql));
    const stoken = makeSecureToken(sql);
    data.append('stoken', stoken);
    const response = await apiBot.post('query.php', data);
    return response.data;
}

export async function queryBot2 (alias, params) {
    const k = sessionStorage.getItem('k1');
    if (!k) {
        await secretService.getKey();
    }

    let request = {
        alias,
        params,
        // trace,
    };
    request = JSON.stringify(request);

    const stoken = makeSecureToken(request);

    request = encrypt(request);

    const data = {
        request,
        stoken,
    };
    return apiBot.post('query2.php', data);
}

export async function queryBot2Many (alias, params) {
    const response = await queryBot2(alias, params);
    return response.data;
}

export async function queryBot3 (type, table, params) {
    const data = {
        type,
        table,
        params,
    };
    return apiBot.post('query3.php', data);
}

export function uploadFile (
    file,
    context,
    keepName = false,
    checksum = false,
    fullData = false,
    subfolder = undefined,
    filename = undefined,
) {
    const data = new FormData();
    if (filename) {
        data.append('userfile', file, filename);
    } else {
        data.append('userfile', file);
    }
    data.append('keepName', keepName ? 1 : 0);
    data.append('checksum', checksum);
    if (subfolder) {
        data.append('subfolder', subfolder);
    }
    return new Promise((resolve, reject) => {
        api.post('upload.php', data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (event) => {
                    context.uploadProgress = event.loaded / event.total;
                },
            })
            .then((response) => {
                if (response.data && response.data.status) {
                    if (response.data.status === 'OK') {
                        context.uploadProgress = 1;
                        resolve(fullData ? response.data : response.data.url);
                    } else {
                        reject(response);
                        console.error(response);
                    }
                } else {
                    reject(response);
                    console.log('reject', response);
                }
                setTimeout(() => {
                    context.uploadProgress = 0;
                }, 1000);
            })
            .catch((error) => {
                reject(error);
                console.log(error);
            });
    });
    // return api.post('upload.php', data);
}

export function uploadImage (file, context, options = {}) {
    const data = new FormData();
    Object.entries(options).forEach(i => {
        const [key, value] = i;
        data.append(`${key}`, value);
    });
    data.append('userfile', file);
    // data.append('keepName', keepName ? 1 : 0);
    return new Promise((resolve, reject) => {
        api.post('resize.php', data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (event) => {
                    context.uploadProgress = event.loaded / event.total;
                },
            })
            .then((response) => {
                if (response.data && response.data.status) {
                    if (response.data.status === 'OK') {
                        context.uploadProgress = 1;
                        resolve(response.data.url);
                    } else {
                        reject(response);
                        console.error(response);
                    }
                } else {
                    reject(response);
                    console.log('reject', response);
                }
                setTimeout(() => {
                    context.uploadProgress = 0;
                }, 1000);
            })
            .catch((error) => {
                reject(error);
                console.log(error);
            });
    });
    // return api.post('upload.php', data);
}

export async function sendTelegramMessage (chatId, text, button = undefined) {
    const token = api.botToken;
    text = text.replaceAll('#', '%23');

    let replyMarkup = {};
    if (button) {
        replyMarkup = {
            inline_keyboard: [
                [{ text: button.title, url: encodeURI(button.url) }],
            ],
        };
    }
    const url = `https://api.telegram.org/bot${token}/sendMessage?chat_id=${chatId}&parse_mode=HTML&text=${text}&reply_markup=${JSON.stringify(replyMarkup)}`;
    let success = false;
    await api.get(url).then((r) => {
        success = true;
        queryBot(`insert into tg_log (chatId, request, response, endpoint, source) values ('${chatId}', '${url}', '${JSON.stringify(r.data)}', '', 'axios.js')`);
    }).catch((e) => {
        console.error(e.toString());
    });
    return success;
}

export async function sendVkMessage (vkId, message, button = undefined) {
    const url = 'https://sot.club/sot.bot/vk_app/api/send_message.php';
    const data = new FormData();
    data.append('vk_id', vkId);
    data.append('message', message);

    if (button) {
        const keyboard = {
            inline: true,
            buttons: [
                [
                    {
                        action: {
                            type: 'open_link',
                            link: button.url,
                            label: button.title,
                        },
                    },
                ],
            ],
        };
        data.append('keyboard', JSON.stringify(keyboard));
    }

    return apiBot.post(url, data).then(() => {
        // this.$q.notify('Сообщение отправлено');
    }).catch((e) => {
        const str = e.response.data;
        if (str) {
            if (str.includes('error_code') && str.includes('901')) {
                console.error(e.response.data);
                // this.$q.notify('Ошибка отправки сообщения ВКонтакте. Пользователю отправлен запрос на разрешение сообщений сообщества Клуб СОТ');
                return;
            }
        }
        // this.$q.notify('Ошибка отправки сообщения ВКонтакте, дополнительная информация в консоли браузера');
        console.error(e);
        console.error(e.response);
        console.error(e.response.data);
    });
}

export async function sendMessageToUser (user, text, button = undefined) {
    if (user.chat_channel === 'tg' || !user.chat_channel) {
        sendTelegramMessage(user.chat_id, text, button);
        return;
    }
    if (user.chat_channel === 'vk' && user.vk_id) {
        sendVkMessage(user.vk_id, text, button);
        return;
    }
    sendTelegramMessage(user.chat_id, text);
}

export function removeTelegramMessage (userId, messageId) {
    const token = api.botToken;
    // debug
    // https://api.telegram.org/bot1976647014:AAEd0UwryDtjWKHeuJF1sbCneO5Dvf3iHAY/deleteMessage?chat_id=293490626&message_id=4826
    const url = encodeURI(`https://api.telegram.org/bot${token}/deleteMessage?chat_id=${userId}&message_id=${messageId}`);
    api.get(url).then(() => {
    }).catch((e) => {
        console.error(e.toString());
    });
}

/*
//  todo: - технический долг, вынести куда то в encoders
const DMap = {
    0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 1027: 129, 8225: 135, 1046: 198, 8222: 132, 1047: 199, 1168: 165, 1048: 200, 1113: 154, 1049: 201, 1045: 197, 1050: 202, 1028: 170, 160: 160, 1040: 192, 1051: 203, 164: 164, 166: 166, 167: 167, 169: 169, 171: 171, 172: 172, 173: 173, 174: 174, 1053: 205, 176: 176, 177: 177, 1114: 156, 181: 181, 182: 182, 183: 183, 8221: 148, 187: 187, 1029: 189, 1056: 208, 1057: 209, 1058: 210, 8364: 136, 1112: 188, 1115: 158, 1059: 211, 1060: 212, 1030: 178, 1061: 213, 1062: 214, 1063: 215, 1116: 157, 1064: 216, 1065: 217, 1031: 175, 1066: 218, 1067: 219, 1068: 220, 1069: 221, 1070: 222, 1032: 163, 8226: 149, 1071: 223, 1072: 224, 8482: 153, 1073: 225, 8240: 137, 1118: 162, 1074: 226, 1110: 179, 8230: 133, 1075: 227, 1033: 138, 1076: 228, 1077: 229, 8211: 150, 1078: 230, 1119: 159, 1079: 231, 1042: 194, 1080: 232, 1034: 140, 1025: 168, 1081: 233, 1082: 234, 8212: 151, 1083: 235, 1169: 180, 1084: 236, 1052: 204, 1085: 237, 1035: 142, 1086: 238, 1087: 239, 1088: 240, 1089: 241, 1090: 242, 1036: 141, 1041: 193, 1091: 243, 1092: 244, 8224: 134, 1093: 245, 8470: 185, 1094: 246, 1054: 206, 1095: 247, 1096: 248, 8249: 139, 1097: 249, 1098: 250, 1044: 196, 1099: 251, 1111: 191, 1055: 207, 1100: 252, 1038: 161, 8220: 147, 1101: 253, 8250: 155, 1102: 254, 8216: 145, 1103: 255, 1043: 195, 1105: 184, 1039: 143, 1026: 128, 1106: 144, 8218: 130, 1107: 131, 8217: 146, 1108: 186, 1109: 190,
};

function unicodeToWin1251UrlEncoded (s) {
    const L = [];
    for (let i = 0; i < s.length; i += 1) {
        const ord = s.charCodeAt(i);
        if (!(ord in DMap)) break;
        L.push(`%${DMap[ord].toString(16)}`);
    }
    return L.join('').toUpperCase();
}
*/

export async function sendSmsMessage (tel, text) {
    console.log(tel);
    console.log(text);
}

export function isTg (chatId) {
    // eslint-disable-next-line func-names
    const filterInt = function (value) {
        // eslint-disable-next-line no-useless-escape
        if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) { return Number(value); }
        return NaN;
    };
    const v = filterInt(chatId);
    return !Number.isNaN(v);
}

export async function uploadToS3 (file, fileUrl, taskId, userId) {
    const reader = new FileReader();
    reader.onload = async () => {
        const sha2 = sha256(reader.result);
        const s3Result = await axios.get(`${window.location.origin}/sot.bot/api/s3_upload.php?url=${fileUrl}`);

        const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
        const s3Url = `https://s3.dtln.ru/1tbucket/${filename}`;
        const sql = 'insert into s3_files '
            + ' (user_id, task_id, file_url, file_name, content_type, length, sha2, s3_url, s3_response) '
            + ' values '
            + ` ('${userId}', '${taskId}', '${fileUrl}', '${file.name}', '${file.type}', '${file.size}', '${sha2}', '${s3Url}', '${JSON.stringify(s3Result)}') `;
        queryBot(sql);
    };
    reader.readAsArrayBuffer(file);
}

/**
 * фишка для запросов через редиректы на апи
 * @type {{post(*, *): Promise<Promise<AxiosResponse<any>> | Promise<axios.AxiosResponse<any>> | *>, get(*): Promise<Promise<AxiosResponse<any>> | Promise<axios.AxiosResponse<any>> | *>}}
 */
export const nodeback = {
    async get (requestUrl) {
        return axios.get(`${window.location.origin}/api/redirect_to_api.php?api_url=${requestUrl}`);
    },
    async post (requestUrl, postData) {
        return axios.post(`${window.location.origin}/api/redirect_to_api.php?api_url=${requestUrl}`, postData);
    },
};
